<!-- Created by henian.xu on 2020/5/26. -->

<template>
    <Container>
        <List
            class="ma-t"
            padding
            margin
        >
            <ScheduleItem
                v-for="item in listData"
                :key="item.id"
                :data="item"
                :to="`/schedule/Detail/${item.id}`"
            />
        </List>
        <Pagination
            ref="infinite"
            :disabled="paginationDisabled"
            @load="onload"
        />
    </Container>
</template>

<script>
import { paginationMixin } from 'mixins/index';
import ScheduleItem from './_ScheduleItem';

export default {
    name: 'ScheduleList',
    components: { ScheduleItem },
    mixins: [paginationMixin],
    data() {
        return {};
    },
    props: {
        status: {
            type: String,
            required: true,
        },
    },
    methods: {
        async getListData(params) {
            const { status: verticalGroupingStatus } = this;
            const res = await this.$api.Member.Ce.VerticalGrouping.verticalGroupingList({
                verticalGroupingStatus,
                ...params,
            });
            this.listData.push(...res.data);
            return res;
        },
    },
};
</script>

<style lang="scss">
</style>
